const permits = JSON.parse(localStorage.getItem('permits'));
// export const menuItems = JSON.parse(permits);
let Items = '';
switch (permits.permit) {
    case 'admin':
        Items = [

            {
                id: 7,
                isLayout: true
            },
            {
                id: 11,
                label: "menuitems.tarjetas.text",
                isTitle: true
            },
            {
                id: 10,
                label: "menuitems.chat.text",
                icon: "bx-user-circle",
                link: "../Mujeres",
                subItems:[
                    {
                        id: 50,
                        label: 'Mujeres',
                        icon: "bx-user-circle",
                        link: "../Mujeres",
                        parentId: 10
                    },
                    {
                        id: 51,
                        label: 'Buscador',
                        link: '../buscadorMujeres',
                        parentId: 10
                    }
                ]
            },
            {
                id: 21,
                label: "menuitems.crypto.text",
                icon: "bx-detail",
                link: "../Tarjetas",
                subItems:[
                    {
                        id: 52,
                        label:"Tarjetas",
                        icon: "bx-detail",
                        link: "../Tarjetas",
                        parentId: 21
                    },
                    {
                        id: 53,
                        label: 'Buscador',
                        link: '../buscadorTarjetas',
                        parentId: 21
                    },
                    {
                        id: 100,
                        label: 'Registro Masivo',
                        link: '../RegistroMasivo',
                        parentId: 21
                    }
                ]
            },
            {
                id: 22,
                label: "menuitems.curptarjeta.text",
                icon: "bx-add-to-queue",
                link: "../AsignacionCurpTarjeta",
            },
            {
                id: 54,
                label: "menuitems.entidades.text",
                isTitle: true
            },
            {
                id: 29,
                label: "menuitems.email.text",
                icon: "bx-map",
                link: "../Municipios",
            },
            {
                id: 34,
                label: "menuitems.invoices.text",
                icon: "bx-briefcase",
                link: "../Empresas",
            },
            {
                id: 39,
                label: "menuitems.comercial.text",
                isTitle: true
            },
            {
                id: 42,
                label: "menuitems.tasks.text",
                icon: "bx-store",
                link: "../Negocios",
            },
            {
                id: 46,
                label: "menuitems.contacts.text",
                icon: "bx-list-ul",
                link: "../Categorias",
            },
            {
                id: 50, 
                label: "menuitems.blog.text",
                icon: "bx-purchase-tag-alt",
                link: "../Descuentos",
            },
            {
                id: 78,
                label: "menuitems.administracion.text",
                isTitle: true
            },
            {
                id: 98,
                label: "menuitems.forms.text",
                icon: "bxs-bar-chart-alt-2",
                link: "../Reportes",
            },
            {
                id: 108,
                icon: "bxs-user-detail",
                label: "menuitems.tables.text",
                link: "../UsuariosAdmin",
            },
            {
                id: 111,
                icon: "bx-aperture",
                label: "menuitems.charts.text",
                link: "../PuntosVenta",
            },
        ];
        break;
    case 'empresa':
        Items = [

            {
                "id": 7,
                "isLayout": true
            },
            {
                "id": 54,
                "label": "menuitems.tarjetas.text",
                "isTitle": true
            },
            
            {
                "id": 21,
                "label": "menuitems.crypto.text",
                "icon": "bx-detail",
                "link": "../Tarjetas"
            },
            {
                id: 22,
                label: "menuitems.curptarjeta.text",
                icon: "bx-add-to-queue",
                link: "../AsignacionCurpTarjeta",
            },
            {
                id: 78,
                label: "menuitems.administracion.text",
                isTitle: true
            },
            {
                id: 98,
                label: "menuitems.forms.text",
                icon: "bxs-bar-chart-alt-2",
                link: "../Reportes",
            },
            
        ];    
        break;
    
    case 'negocio':

        Items = [

            {
                id: 78,
                label: "menuitems.administracion.text",
                isTitle: true
            },
            {
                id: 111,
                icon: "bx-aperture",
                label: "menuitems.charts.text",
                link: "../PuntosVenta",
            },
        ];

        break;

    case 'capturista':

        Items = [

            {
                id: 11,
                label: "menuitems.tarjetas.text",
                isTitle: true
            },
            {
                id: 10,
                label: "menuitems.chat.text",
                icon: "bx-user-circle",
                link: "../Mujeres",
            },
            {
                id: 21,
                label: "menuitems.crypto.text",
                icon: "bx-detail",
                link: "../Tarjetas",
            },
            {
                id: 22,
                label: "menuitems.curptarjeta.text",
                icon: "bx-add-to-queue",
                link: "../AsignacionCurpTarjeta",
            },
        ];
        
        break;

    case 'municipio':
        Items = [
            {
                id: 11,
                label: "menuitems.tarjetas.text",
                isTitle: true
            },
            {
                id: 10,
                label: "menuitems.chat.text",
                icon: "bx-user-circle",
                link: "../Mujeres",
            },
            {
                id: 54,
                label: "menuitems.entidades.text",
                isTitle: true
            },
            {
                id: 34,
                label: "menuitems.invoices.text",
                icon: "bx-briefcase",
                link: "../Empresas",
            },
            {
                id: 78,
                label: "menuitems.administracion.text",
                isTitle: true
            },
            {
                id: 98,
                label: "menuitems.forms.text",
                icon: "bxs-bar-chart-alt-2",
                link: "../Reportes",
            },
        ];
        
        break;
    
    case 'gerente':

        Items = [
            {
                id: 78,
                label: "menuitems.administracion.text",
                isTitle: true
            },
            {
                id: 98,
                label: "menuitems.forms.text",
                icon: "bxs-bar-chart-alt-2",
                link: "../Reportes",
            },
            {
                id: 111,
                icon: "bx-aperture",
                label: "menuitems.charts.text",
                link: "../PuntosVenta",
            },
        ];

        break;

    case 'admin_municipio':
        Items = [

            {
                id: 7,
                isLayout: true
            },
            {
                id: 11,
                label: "menuitems.tarjetas.text",
                isTitle: true
            },
            {
                id: 10,
                label: "menuitems.chat.text",
                icon: "bx-user-circle",
                link: "../Mujeres",
                subItems:[
                    {
                        id: 50,
                        label: 'Mujeres',
                        icon: "bx-user-circle",
                        link: "../Mujeres",
                        parentId: 10
                    },
                    {
                        id: 51,
                        label: 'Buscador',
                        link: '../buscadorMujeres',
                        parentId: 10
                    }
                ]
            },
            {
                id: 21,
                label: "menuitems.crypto.text",
                icon: "bx-detail",
                link: "../Tarjetas",
                subItems:[
                    {
                        id: 52,
                        label:"Tarjetas",
                        icon: "bx-detail",
                        link: "../Tarjetas",
                        parentId: 21
                    },
                    {
                        id: 53,
                        label: 'Buscador',
                        link: '../buscadorTarjetas',
                        parentId: 21
                    }
                ]
            },
            {
                id: 22,
                label: "menuitems.curptarjeta.text",
                icon: "bx-add-to-queue",
                link: "../AsignacionCurpTarjeta",
            },
            {
                id: 54,
                label: "menuitems.entidades.text",
                isTitle: true
            },
            {
                id: 34,
                label: "menuitems.invoices.text",
                icon: "bx-briefcase",
                link: "../Empresas",
            },
            {
                id: 78,
                label: "menuitems.administracion.text",
                isTitle: true
            },
            {
                id: 98,
                label: "menuitems.forms.text",
                icon: "bxs-bar-chart-alt-2",
                link: "../Reportes",
            },
        ];
        break;
}

export const menuItems = Items;


